<template>
  <div class="sidebar-wrapper">
    <div class="left-sidebar" :class="sideMenu ? 'active' : ''">
      <div class="user-profile">
        <div class="user-profile_ribbon">
          <h5 class="user-profile_ribbon-title font-weight-bold">
            {{ authentication.user_name }}
          </h5>
          <span class="close-side" :class="sideMenu ? 'active' : ''" @click="hideSideBar()">
            &times;</span>
        </div>
        <div class="img-container">
          <img src="/weapsmithing/images/pro-1.png" alt="" class="z-index" />
          <img src="/weapsmithing/images/logo.png" class="weaponSmithing-logo" alt="" />
        </div>
        <div class="
            left-sidebar-text
            d-flex
            align-items-center
            justify-content-center
          ">
          <h6 class="sidebar-text-level" v-if="balance[0]">
            {{ mcc }} MCC
          </h6>
          <h6 class="sidebar-text-level" v-else>
            0 MCC
          </h6>
          <div class="dropdown">
            <a href="javascript:void(0)" data-toggle="dropdown">
              <img src="/weapsmithing/images/settings.png" class="img-fluid" alt="setting" @click="isOpen" />
            </a>
            <div class="dropdown-menu" aria-labelledby="my-dropdown" :class="showHideDropdown ? 'show' : ''">
              <a class="dropdown-item" href="javascript:void(0)" @click="withdrawModal">Withdraw</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="depositModal">Deposit</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="logout()">Logout</a>
            </div>
          </div>
        </div>
      </div>

      <section class="left-sidebar-content miniscreen_scrollbar">
        <div class="menu-button">
          <div class="inventory-btn position-relative">
            <img src="/weapsmithing/images/menu-button.png" alt="" />
            <router-link to="/">
              <h3>Inventory</h3>
              <div class="bg-img" :class="$route.meta.sideBarKey == 'Dashboard' ? 'active' : ''"></div>
            </router-link>
          </div>
          <div class="craft-btn position-relative my-4">
            <img src="/weapsmithing/images/menu-button.png" alt="" />
            <a href="javascript:void(0)" @click="pushToCraft">
              <h3>Craft</h3>
              <div class="bg-img" :class="$route.meta.sideBarKey == 'craft' ? 'active' : ''"></div>
            </a>
          </div>
          <div class="stake-btn position-relative">
            <img src="/weapsmithing/images/menu-button.png" alt="" />
            <a href="#" @click="pushToStaked">
              <h3>stake</h3>
              <div class="bg-img" :class="$route.meta.sideBarKey == 'staked' ? 'active' : ''"></div>
            </a>
          </div>
        </div>
        <div class="adventure">
          <router-link to="/mission" class="btn btn-secondary">
            Mission
          </router-link>
          <div class="
              adventure-level-energy
              d-flex
              mt-4
              align-items-center
              justify-content-center
            ">
            <img src="/weapsmithing/images/energy-icon.png" alt="" />
            <h6 class="text-white mt-2 mx-3">20/20</h6>
          </div>
        </div>
      </section>
    </div>
    <WithdrawModal v-if="showWithdraw" v-on:w-modal-hide-click="showWithdraw = false" />
    <depositModal v-if="showDeposit" v-on:w-modal-hide-click="showDeposit = false" />
  </div>
</template>

<script>
import router from "../router/index";
import WithdrawModal from "@/components/WithdrawModal";
import DepositModal from "@/components/DepositModal";
import { mapGetters } from "vuex";
import { reactive } from "vue";
export default {
  name: "Sidebar",
  props: ["showSidebar"],
  computed: {
    ...mapGetters(["balance", "mcc"]),
    sideMenu: function () {
      return this.showSidebar;
    },
  },
  components: {
    WithdrawModal,
    DepositModal,
  },
  data() {
    return {
      isActive: "",
      showWithdraw: false,
      showDeposit: false,
      showHideDropdown: false,
    };
  },
  setup() {
    const authentication = reactive({
      user_name: localStorage.getItem("wax_user"),
    });
    return {
      authentication,
    };
  },
  methods: {
    hideSideBar() {
      this.$emit("hideSideBar");
    },
    pushToCraft: () => {
      router.push("/craft");
    },
    pushToStaked: () => {
      router.push("/staked");
    },
    withdrawModal() {
      this.showHideDropdown = false;
      this.showWithdraw = true;
    },
    depositModal() {
      this.showHideDropdown = false;
      this.showDeposit = true;
    },
    isOpen() {
      this.showHideDropdown = this.showHideDropdown ? false : true;
    },
    logout: () => {
      localStorage.clear();
      router.push("/login");
    },
  },
};
</script>

<style>
.left-sidebar-text .btn-secondary {
  height: 35px;
}
.sidebar-text-level {
  font-size: 18px;
}
.left-sidebar-text .dropdown {
  width: 35px;
  margin-left: 8px;
}
.left-sidebar-text .dropdown-menu {
  color: #fff;
  background: var(--linear-gradient);
  filter: var(--filterShadow);
  border: none;
  min-width: 100% !important;
}
.left-sidebar-text .dropdown-menu .dropdown-item {
  color: #fff;
  font-weight: bold;
  transition: all 0.4s;
}
.dropdown-menu .dropdown-item:hover {
  background: transparent !important;
  color: rgb(160, 148, 148);
}
.dropdown_modal .craft-weapon_list {
  margin: auto;
}
</style>